<template>
  <v-stepper v-model="step" vertical class="elevation-0" style="width: 100%;">
    <v-stepper-step :complete="step > 1" :step="1">
      {{ $t("components.create_mass_notes_form.insert_sins") }}
      <small>
        {{ $t("components.create_mass_notes_form.copy_paste_or_type_sins") }}
      </small>
    </v-stepper-step>

    <v-stepper-content :step="1">
      <div row justify-center>
        <v-form ref="sinForm" v-model="valid.sins">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  :label="$t('components.create_mass_notes_form.sins')"
                  :value="sins"
                  @input="parse($event)"
                  auto-grow
                  :rules="[$rules.required,rules.max1500]"
                  class="required"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </div>
      <v-btn color="primary" @click="step = 2" :disabled="!valid.sins">
        {{ $t("globals.continue") }}
      </v-btn>
    </v-stepper-content>
    <v-stepper-step :complete="step > 2" :step="2">
      {{ $t("components.create_mass_notes_form.create_note") }}
      <small>
        {{ $t("components.inmemorystores.fill_in_the_fields") }}
      </small>
    </v-stepper-step>
    <v-stepper-content :step="2">
      <div row justify-center>
        <v-form ref="noteForm" v-model="valid.note">
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <no-autocomplete-textfield
                  v-model="note.Title"
                  :label="$t('globals.title')"
                  :rules="[$rules.required]"
                  autocomplete="off"
                  class="required"
                />
              </v-col>
              <v-col cols="12" md="4">
                <trans-enum
                  :value.sync="note.Category"
                  :items="options.Enums.NoteCategory"
                  :label="$t('globals.category')"
                  :rules="[$rules.required]"
                  class="required"
                ></trans-enum>
              </v-col>
              <v-col cols="12">
                <quill-editor v-model="note.Text" />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </div>
      <v-btn text @click="step = 1">
        {{ $t("globals.back") }}
      </v-btn>
    </v-stepper-content>
  </v-stepper>
</template>

<script>
import { mapGetters } from "vuex";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import TransEnum from "@/components/TransEnum.vue";

export default {
  components: {
    NoAutocompleteTextfield,
    TransEnum,
  },
  props: [],
  data() {
    return {
      valid: {
        sins: false,
        note: false,
      },
      note: {
        Title: "",
        Text: "",
        Category: null,
      },
      sins: "",
      step: 1,
      rules:{
        max1500: (v) => this.countSins(v) <= 1500 || this.$t("validation.must_be_up_to_1500")
      }
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
  },
  watch:{
    "valid.sins": {
      handler(v) {
        this.$emit("valid", this.isValid());
      }
    },
    "valid.note": {
      handler(v) {
        this.$emit("valid", this.isValid());
      }
    }
  },
  methods: {
    parse(v) {
      // console.log(JSON.stringify(v));
      this.sins = v.replace(/[\r\n ]/gm, ',');
      // this.sins = v.replaceAll("\n", ",");
      // this.sins = v.replaceAll("\r", ",");
      // this.sins = v.replaceAll(" ", ",");
      // console.log(JSON.stringify(this.sins));
    },
    countSins(v) {
      console.log(JSON.stringify(v));
      return v.split(",").length;
    },
    isValid() {
      console.log(this.valid.sins && this.valid.note, this.valid);
      return this.valid.sins && this.valid.note;
    },
  },
};
</script>
